module.exports = __webpack_public_path__ + "img/device_c1_one.485c222e.jpg";